import {
  base_colorAction,
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  base_contentSelected,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { transition_fast } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

// Mirrors the receipt-capture WideDropzone affordance (dashed border, secondary
// surface, hover-to-action accent) for reusable single-file CSV upload flows.
// `isDragActive` is the only genuinely dynamic value, so this is a factory.
export const dropzone = (isDragActive: boolean) => css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing(2)};
  padding: ${spacing(12)} ${spacing(4)};
  border: 1.5px dashed
    ${isDragActive ? base_colorAction : base_colorContentBorder};
  background-color: ${isDragActive
    ? base_contentSelected
    : base_colorSurfaceSecondary};
  border-radius: ${cornerRadius};
  cursor: pointer;
  text-align: center;
  font-family: ${font_family_weight_regular};
  transition:
    background-color ${transition_fast} ease-out,
    border-color ${transition_fast} ease-out;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:hover {
    border-color: ${base_colorAction};
    background-color: ${base_contentSelected};
  }

  /* Keyboard focus must stay visible — the hidden input owns focus, so we lift
     the visible ring up onto the dropzone shell via :focus-within. */
  &:focus-within {
    border-color: ${base_colorAction};
    box-shadow: 0 0 0 3px ${base_colorAction}33;
    outline: none;
  }
`

export const icon = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spacing(1)};
`

export const primary = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
`

export const link = css`
  color: ${base_colorAction};
  text-decoration: underline;
`

export const hint = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

// react-dropzone's hidden file input keeps its native semantics (so screen
// readers announce a file upload control) while staying visually hidden.
export const visuallyHiddenInput = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
